import { render, staticRenderFns } from "./RecentSiteVisits.vue?vue&type=template&id=183d05d4&scoped=true&"
import script from "./RecentSiteVisits.vue?vue&type=script&lang=js&"
export * from "./RecentSiteVisits.vue?vue&type=script&lang=js&"
import style0 from "./RecentSiteVisits.vue?vue&type=style&index=0&id=183d05d4&prod&scoped=true&lang=css&"
import style1 from "./RecentSiteVisits.vue?vue&type=style&index=1&id=183d05d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183d05d4",
  null
  
)

export default component.exports